import { fetchLegacyUserDomainData } from '../actions/fetchLegacyUserDomainData';
import store from '../store/store';
import { SubscriberType } from '../contracts/subscriberType';
import isDeprecateLegacyPremiumEnabled from './isDeprecateLegacyPremiumEnabled';
export function isOutlookPremiumOptionHidden(): boolean {
    fetchLegacyUserDomainData();
    var isLegacyPremiumTenantEmpty = store.legacyPremiumTenant.TenantName == null;
    if (!isDeprecateLegacyPremiumEnabled()) {
        return true;
    }
    return store.subscriberType == SubscriberType.Primary || isLegacyPremiumTenantEmpty;
}
